import NotFound from './NotFound'
import './NotFound.css'

export default NotFound



// WEBPACK FOOTER //
// ./src/components/NotFound/index.js